<template>
  <div class="animated fadeIn">
    <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
      <b-row style="min-width: 1200px;">
        <b-col sm="12">
          <div style="margin-top:-7px;">
            <!-- <span class="card-title wise-card-header">광고효과예측 게시판 관리 시스템</span> -->
          </div>
          <!-- <div class="wise-small-header">Board Management</div> -->
        </b-col>
      </b-row>
      <b-row style="padding-top:20px">
      </b-row>
    </b-card>
    <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
      <b-row style="min-width: 1200px;height:700px;">
        <b-col sm="6">

          <b-row>
            <b-col sm="3">
              <input style="margin-left:5px;" v-model="filter" class="form-control" placeholder="검색" type="text"></input>
            </b-col>
            <b-col sm="3">
              <select id="startDate" class="form-control" v-model="selectedGubunOption" v-on:change="selectedGubun()">
                <option>전체</option>
                <option>공지사항</option>
                <option>자주묻는질문</option>
              </select>
            </b-col>
            <b-col sm="3">
              <b-button block variant="outline-primary" class="btn" @click="selectedGubun()">
                <span style="font-weight:900;">신규 게시물</span>
              </b-button>
            </b-col>
            <b-col sm="3">
              <!-- <b-button block variant="outline-primary" class="btn" @click="selectedGubun()">
                <span style="font-weight:900;">게시물 삭제</span>
              </b-button> -->
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12">
              <table  id="table"
                      data-search="false"
                      data-show-columns="false"
                      data-pagination="true"
                      data-detail-view="false"
                      data-detail-formatter="detailFormatter"
                      >
                  <thead>
                      <tr>
                          <!-- <th data-field="graphId">Index</th> -->
                          <th data-field="type">구분</th>
                          <th data-field="title">제목</th>
                          <th data-field="top_yn">게시여부</th>
                          <th data-field="notice_yn">최상단여부</th>
                          <th data-field="registration_dt">등록일자</th>
                          <!-- <th data-field="cpm">CPM</th> -->
                          <!-- <th data-field="eImp">E.Imp</th> -->
                          <!-- <th data-field="grps">GRPs</th> -->
                          <!-- <th data-field="reach1" >Reach 1+</th> -->
                      </tr>
                  </thead>
              </table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="padding-top:20px">
      </b-row>
    </b-card>
  </div>
</template>

</style><style src="bootstrap-table/dist/bootstrap-table.min.css"></style>
<script>
import bootstrapTable from "bootstrap-table";

export default {
  data(){
    return {
      filter : null,
      selectedGubunOption : '전체',
      contentsList:null,
      content:null
    }
  },
  created: function() {

  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    this.$http.get('/api/select/selectManagerBoardDataAll?access_token='+token)
    .then((result) => {
      this.contentsList = result.data;
      this.createTable();
    })

  },
  methods: {
    selectedGubun(){
      // if(this.selectedMonthly == '월별'){
      //   this.formData.monthly = true;
      // }else{
      //   this.formData.monthly = false;
      // }
    },
    changeContent(content){
      console.log(content);
      this.content = content;
    },
    createTable(){
      var self = this;
      $(function () {
          $('#table').bootstrapTable({
              height : 400,
              data: self.contentsList,
              onClickRow: function (row, $element) {
                $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
                self.changeContent((row));
              },
          });

          $('#table').on('click-row.bs.table', function (e, row, $element) {
            $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
          });
          $("#table>tbody>tr:first").trigger('click');

          $(".mybtn-top").click(function () {
              $('#table').bootstrapTable('scrollTo', 0);
          });

          $(".mybtn-row").click(function () {
            alert('asdasd');
              var index = +$('.row-index').val(),
                  top = 0;
              $('#table').find('tbody tr').each(function (i) {
                if (i < index) {
                    top += $(this).height();
                  }
              });
              $('#table').bootstrapTable('scrollTo', top);
          });

          $(".mybtn-btm").click(function () {
              $('#table').bootstrapTable('scrollTo', 'bottom');
          });
          var first = $("#table > tbody tr:first")
          $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
      });
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/management/board/BoardManager.vue